/*
let list = [];
let set = [];

list.push(...[...document.querySelectorAll('div[style*="hsla(var(--item-unique-contrast))"] span')].map(e => e.innerText).filter(t => !t.includes('%')))
set = [...new Set(list)];
list = [];
*/

import { ClassType } from "./classes";

export const classSpecificUniques: Record<ClassType, string[]>  = {
  "Huntress": [
    "Tangletongue",
    "Ingenuity",
    "Hand of Wisdom and Action",
    "Lycosidae",
    "Sacred Flame",
    "Beacon of Azis",
    "Essentia Sanguis",
    "Sanguis Heroum",
    "From Nothing",
    "Against the Darkness",
    "Morior Invictus",
    "Nascent Hope",
    "Effigy of Cruelty",
    "Arakaali's Gift",
    "Kitoko's Current",
    "Controlled Metamorphosis",
    "Forsaken Bangle",
    "The Black Insignia",
    "Headhunter",
    "Olroth's Resolve",
    "Valako's Roar",
    "Andvarius",
    "Gravebind",
    "Beira's Anguish",
    "Ngamahu's Chosen",
    "Astramentis",
    "Heroic Tragedy",
    "Crest of Ardura",
    "Alpha's Howl",
    "Breath of the Mountains",
    "Melting Maelstrom",
    "Painter's Servant",
    "Crown of Eyes",
    "Death Rush",
    "Call of the Brotherhood",
    "Wake of Destruction",
    "The Black Cat",
    "Grand Spectrum",
    "Prism of Belief",
    "The Three Dragons",
    "Bloodbarrier",
    "Hyrri's Ire",
    "The Fall of the Axe",
    "Threaded Light"
  ],
  "Ranger": [
    "Tangletongue",
    "Beacon of Azis",
    "Ingenuity",
    "Sacred Flame",
    "Hand of Wisdom and Action",
    "Against the Darkness",
    "Olroth's Resolve",
    "Morior Invictus",
    "Megalomaniac",
    "Forsaken Bangle",
    "Arakaali's Gift",
    "Crown of Eyes",
    "Threaded Light",
    "Effigy of Cruelty",
    "Valako's Roar",
    "Crest of Ardura",
    "Prism of Belief",
    "Beira's Anguish",
    "Hyrri's Ire",
    "Leopold's Applause",
    "Breath of the Mountains",
    "The Fall of the Axe",
    "Astramentis",
    "Heroic Tragedy",
    "Death Rush",
    "Voltaxic Rift",
    "Redblade Banner",
    "Radiant Grief",
    "Melting Maelstrom",
    "Skysliver"
  ],
  "Witch": [
    "Ingenuity",
    "Tangletongue",
    "From Nothing",
    "Atziri's Disdain",
    "Crown of Eyes",
    "Atziri's Acuity",
    "Choir of the Storm",
    "Nascent Hope",
    "Sanguis Heroum",
    "Sunsplinter",
    "Beira's Anguish",
    "Megalomaniac",
    "Morior Invictus",
    "Forsaken Bangle",
    "Seed of Cataclysm",
    "Soul Tether",
    "Prism of Belief",
    "Rathpith Globe",
    "Threaded Light",
    "Sacred Flame",
    "Blackflame",
    "Arakaali's Gift",
    "Trenchtimbre",
    "Alpha's Howl",
    "Hand of Wisdom and Action",
    "Ventor's Gamble",
    "Ngamahu's Chosen",
    "Sire of Shards",
    "Against the Darkness",
    "Grand Spectrum",
    "Pragmatism",
    "Bijouborne",
    "Mask of the Sanguimancer",
    "Doedre's Tenure",
    "Evergrasping Ring",
    "Strugglescream",
    "Bones of Ullr",
    "Melting Maelstrom",
    "Waveshaper",
    "Beacon of Azis",
    "Levinstone",
    "Saitha's Spear",
    "Crest of Ardura",
    "Olroth's Resolve",
    "Redblade Banner",
    "Veil of the Night",
    "Chernobog's Pillar",
    "Headhunter",
    "Trampletoe",
    "Valako's Roar",
    "Skysliver",
    "Breath of the Mountains",
    "Controlled Metamorphosis",
    "Enfolding Dawn"
  ],
  "Sorceress": [
    "Ingenuity",
    "Maligaro's Virtuosity",
    "From Nothing",
    "Prism of Belief",
    "Controlled Metamorphosis",
    "Morior Invictus",
    "Megalomaniac",
    "Sacrosanctum",
    "Choir of the Storm",
    "Sire of Shards",
    "Nightscale",
    "Midnight Braid",
    "Nascent Hope",
    "Gravebind",
    "Snakepit",
    "Merit of Service",
    "Sanguis Heroum",
    "Arakaali's Gift",
    "Melting Maelstrom",
    "Arvil's Wheel",
    "Beira's Anguish",
    "Scold's Bridle",
    "Tangletongue",
    "Doedre's Damning",
    "Andvarius",
    "The Prisoner's Manacles",
    "Forsaken Bangle",
    "Hand of Wisdom and Action",
    "Fireflower",
    "Doedre's Tenure",
    "Atziri's Disdain",
    "Crest of Ardura",
    "Waveshaper",
    "Leer Cast",
    "Dream Fragments",
    "The Anvil",
    "Cloak of Defiance",
    "Breath of the Mountains",
    "Alpha's Howl",
    "Threaded Light",
    "Pariah's Embrace",
    "Effigy of Cruelty",
    "Sacred Flame"
  ],
  "Monk": [
    "Ingenuity",
    "Hand of Wisdom and Action",
    "Tangletongue",
    "From Nothing",
    "Against the Darkness",
    "Crown of Eyes",
    "Threaded Light",
    "Sanguis Heroum",
    "Megalomaniac",
    "Nascent Hope",
    "Effigy of Cruelty",
    "Prism of Belief",
    "Arakaali's Gift",
    "Redblade Banner",
    "Atziri's Acuity",
    "Breath of the Mountains",
    "Ngamahu's Chosen",
    "Serpent's Egg",
    "Crest of Ardura",
    "Beira's Anguish",
    "Astramentis",
    "Collapsing Horizon",
    "Valako's Roar",
    "Polcirkeln",
    "Olroth's Resolve",
    "Melting Maelstrom",
    "Headhunter",
    "Forsaken Bangle",
    "Controlled Metamorphosis",
    "Sacred Flame",
    "The Dark Defiler",
    "Powertread",
    "Beacon of Azis"
  ],
  "Warrior": [
    "Trampletoe",
    "Skysliver",
    "Ngamahu's Chosen",
    "From Nothing",
    "Thrillsteel",
    "Against the Darkness",
    "Megalomaniac",
    "Svalinn",
    "Sanguis Heroum",
    "Prism of Belief",
    "Chernobog's Pillar",
    "Forsaken Bangle",
    "Rise of the Phoenix",
    "Ingenuity",
    "Ryslatha's Coil",
    "Arakaali's Gift",
    "Olroth's Resolve",
    "Xoph's Blood",
    "Tangletongue",
    "Morior Invictus",
    "Idol of Uldurn",
    "Beira's Anguish",
    "Nascent Hope",
    "Polcirkeln",
    "The Hollow Mask",
    "Crown of the Pale King",
    "Feathered Fortress",
    "Briarpatch",
    "The Vertex",
    "Grand Spectrum",
    "Death Articulated",
    "The Surrender",
    "Redblade Banner",
    "The Hammer of Faith",
    "Gravebind",
    "Headhunter",
    "Atziri's Acuity",
    "Astramentis",
    "Andvarius",
    "Titanrot Cataphract",
    "Controlled Metamorphosis",
    "Gifts from Above",
    "Mjölner",
    "Melting Maelstrom",
    "Jarngreipr",
    "Breath of the Mountains",
    "Saitha's Spear",
    "Valako's Roar",
    "Hand of Wisdom and Action",
    "Empire's Grasp"
  ],
  "Mercenary": [
    "Ingenuity",
    "Hand of Wisdom and Action",
    "Morior Invictus",
    "From Nothing",
    "Tangletongue",
    "Sanguis Heroum",
    "Prism of Belief",
    "Megalomaniac",
    "Against the Darkness",
    "Arakaali's Gift",
    "Gravebind",
    "Sacred Flame",
    "Beacon of Azis",
    "Valako's Vice",
    "Forsaken Bangle",
    "Andvarius",
    "Nascent Hope",
    "Olroth's Resolve",
    "Beira's Anguish",
    "Painter's Servant",
    "The Hammer of Faith",
    "Astramentis",
    "Ngamahu's Chosen",
    "Blueflame Bracers",
    "Cloak of Flame",
    "Blackflame",
    "Heroic Tragedy",
    "Alpha's Howl",
    "Radiant Grief",
    "Merit of Service",
    "Controlled Metamorphosis",
    "The Coming Calamity",
    "Skysliver",
    "Crest of Ardura",
    "Breath of the Mountains",
    "Trampletoe",
    "Redblade Banner",
    "Sunsplinter",
    "Valako's Roar",
    "Lycosidae",
    "Fixation of Yix",
    "Fireflower",
    "Headhunter",
    "The Three Dragons",
    "Maligaro's Virtuosity",
    "Grand Spectrum",
    "Melting Maelstrom",
    "Gloamgown"
  ],
  "Druid": [ // TODO: correct
    "Trampletoe",
    "Skysliver",
    "Ngamahu's Chosen",
    "From Nothing",
    "Thrillsteel",
    "Against the Darkness",
    "Megalomaniac",
    "Svalinn",
    "Sanguis Heroum",
    "Prism of Belief",
    "Chernobog's Pillar",
    "Forsaken Bangle",
    "Rise of the Phoenix",
    "Ingenuity",
    "Maligaro's Virtuosity",
    "Controlled Metamorphosis",
    "Morior Invictus",
    "Sacrosanctum",
    "Choir of the Storm",
    "Sire of Shards",
    "Nightscale",
    "Midnight Braid",
    "Nascent Hope",
    "Tangletongue",
    "Atziri's Disdain",
    "Crown of Eyes",
    "Atziri's Acuity",
    "Sunsplinter",
    "Beira's Anguish",
  ]
}
